module.exports = __webpack_public_path__ + "img/new_illustration_element.4e47d6d7.png";